<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="考试名称">
              <a-input placeholder="请输入" v-model="where.keyword.testName" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="状态">
              <a-select v-model="where.keyword.examStatus" allowClear>
                <a-select-option value>全部</a-select-option>
                <a-select-option value="0">未发布</a-select-option>
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="2">已结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'考试列表-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo({id:0})" type="primary" v-btnlimit="'考试列表-添加'"/>
      <!-- <pxkeji-btn name="批量启用" v-if="selectRows.length>0" class="pxkeji_basic_btn" />
      <pxkeji-btn name="批量禁用" v-if="selectRows.length>0" class="pxkeji_basic_btn" />-->
      <!-- <pxkeji-btn name="批量删除" @click="batchDelete" v-if="selectRows.length>0" class="pxkeji_basic_btn"/> -->

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="blue">未发布</a-tag>
          <a-tag v-else-if="status==1" color="green">进行中</a-tag>
          <a-tag v-else color="red">已结束</a-tag>
        </span>
        <span slot="trigger" slot-scope="trigger">
          <template v-if="trigger.triggerType==0">学分({{trigger.triggerSetting}})</template>
          <template v-if="trigger.triggerType==1">学时({{trigger.triggerSetting}})</template>
          <template v-if="trigger.triggerType==2">关联课程</template>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="编辑" :roles="[]" size="small" @click="showInfo(info)" type="primary" v-btnlimit="'考试列表-编辑'"/>
          <a-divider type="vertical" />

          <pxkeji-btn
            name="试卷"
            :roles="[]"
            size="small"
            v-btnlimit="'考试列表-试卷'"
            @click="showPaper(info.id,info.questionsCount)"
            type="default"
          />

          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="0">
                <pxkeji-btn
                  name="条件设置"
                  size="small"
                  v-btnlimit="'考试列表-条件设置'"
                  @click="setTrigger(info.id)"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="0">
                <pxkeji-btn
                  name="免学用户"
                  size="small"
                  v-btnlimit="'考试列表-免学用户'"
                  @click="selectStudents(info.id)"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="1">
                <pxkeji-btn
                  name="删除"
                  :roles="[]"
                  size="small"
                  v-btnlimit="'考试列表-删除'"
                  @click="delInfo(info.id)"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="2" v-if="info.examStatus==1">
                <pxkeji-btn
                  name="结束"
                  :roles="[]"
                  v-btnlimit="'考试列表-开启结束'"
                  @click="changeStatus(info.id,2)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="4" v-if="info.examStatus==2">
                <pxkeji-btn
                  name="开启"
                  :roles="[]"
                  v-btnlimit="'考试列表-开启结束'"
                  @click="changeStatus(info.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="3" v-if="info.examStatus>0">
                <pxkeji-btn
                  name="成绩"
                  :roles="[]"
                  v-btnlimit="'考试列表-成绩'"
                  @click="showsScore(info.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'考试列表-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox">
        <div>
          <span>共有考试：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="info.title"
      v-model="info.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :infos="info.data" />
    </a-modal>
    <a-modal
      title="试卷列表"
      v-model="paperinfo.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <PaperList @callbackMethod="hide" :examinationId="paperinfo.id" :limit="paperinfo.limit" />
    </a-modal>
    <a-modal
      title="成绩列表"
      v-model="scoreinfo.visible"
      width="50%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <ScoreList @callbackMethod="hide" :examinationId="scoreinfo.id" />
    </a-modal>
    <a-modal
            title="选择学员"
            v-model="students.visible"
            width="80%"
            :footer="false"
            destroyOnClose
            :maskClosable="false"
    >
      <noLearningStudnetInfo :id="students.id" @callbackMethod="saveStudent" />
    </a-modal>
    <a-modal
      v-model="triggerModal.triggerShow"
      :footer="false"
      destroyOnClose
      width="70%"
      :maskClosable="false"
      class="ui-modal"
    >
      <trigger
        @callbackMethod="closeTrigger"
        :id="triggerModal.id"
      />
    </a-modal>
  </div>
</template>
<script>
import Info from "./examinationInfo.vue"; //添加考试
import PaperList from "./paperslist.vue";
import ScoreList from "./scorelistexam.vue";
import trigger from "./trigger.vue";
import noLearningStudnetInfo from "./noLearningStudentDetail.vue";
const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "序号"
  // },
  {
    dataIndex: "testName",
    key: "testName",
    align: "center",
    title: "考试名称",
  },
  {
    dataIndex: "questionsCount",
    key: "questionsCount",
    align: "center",
    title: "题目数量",
  },
  {
    dataIndex: "passLine",
    key: "passLine",
    align: "center",
    title: "及格分数线",
  },
  {
    dataIndex: "addUser",
    key: "addUser",
    align: "center",
    title: "添加人",
  },
  // {
  //   dataIndex: "examPeople",
  //   key: "examPeople",
  //   align: "center",
  //   title: "考试人数"
  // },
  {
    dataIndex: "trigger",
    key: "trigger",
    align: "center",
    title: "考试条件",
    scopedSlots: { customRender: "trigger" },
  },
  {
    dataIndex: "examStatus",
    key: "examStatus",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];

var that;
export default {
  name: "storelist",
  data() {
    return {
      treeData: [],
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          showTotal: function (total, range) {
            return "共 " + total + " 条";
          },
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          testName: "",
          examStatus: "",
        },
      },
      selectRows: [], //选中项编号
      isloading: false,
      info: {
        title: "",
        visible: false,
        id: 0,
        data: {},
      },
      paperinfo: {
        visible: false,
        id: 0,
        limit: 0,
      },
      scoreinfo: {
        visible: false,
        id: 0,
      },
      triggerModal: {
        triggerShow: false,
        id: 0,
      },
      students: {
        visible: false,
        id: 0,
        studentIds: []
      },
    };
  },
  components: {
    Info,
    PaperList,
    ScoreList,
    trigger,
    noLearningStudnetInfo
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.GetList();
      // this.getTree();
    });
  },
  watch: {
    selectRows: function () {
      //console.log("watch", val);
    },
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    showsScore(id) {
      this.scoreinfo.visible = true;
      this.scoreinfo.id = id;
    },
    setTrigger(id) {
      this.triggerModal.triggerShow = true;
      this.triggerModal.id = id;
    },
    closeTrigger(flag) {
      this.triggerModal.triggerShow = false;
      if (flag) {
        this.GetList();
      }
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.examination
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.testName,
          this.where.keyword.examStatus
        )
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    treeChange(val) {
      this.where.keyword.categoryId = val;
    },
    getTree() {
      this.$api.cms.articlecategory
        .getTree()
        .then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.treeData = res.data;
            res.data.unshift({ label: "根目录", parentid: 0, value: 0 });
            this.where.keyword.categoryId = [res.data[0].value];
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showPaper(id, c) {
      this.paperinfo.visible = true;
      this.paperinfo.id = id;
      this.paperinfo.limit = c;
    },
    //查看
    showInfo(info) {
      this.info.title = info.id ? "编辑" : "添加";
      this.info.visible = true;
      this.info.data = info;
    },
    //子组件传值
    save() {
      this.info.visible = false;
      this.GetList();
    },
    saveStudent() {
      this.students.visible = false;
      this.GetList();
    },
    hide() {
      this.paperinfo.visible = false;
      this.scoreinfo.visible = false;
    },
    selectStudents(id) {
      this.students.visible = true;
      this.students.id = id;
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消",
      });
    },
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          console.log("OK", id);
          that.isloading = true;
          that.$api.examination
            .removeById(id)
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {
          //console.log("Cancel");
        },
      });
    },
    /** 批量删除 */
    batchDelete() {
      this.$confirm({
        title: "您确定要执行批量删除的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.examination
            .deleteByIds(that.selectRows.join(","))
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {},
      });
    },
    changeStatus(id, status) {
      this.$confirm({
        title: "您确定要停止该考试吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.examination
            .updateStatus(id, status)
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

